/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Message_Empty_ErrorInputs */



/**
* | output |
* | --- |
* | "Please enter a valid message" |
*
* @param {Chat_Message_Empty_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_message_empty_error = /** @type {((inputs?: Chat_Message_Empty_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Message_Empty_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte gib eine gültige Nachricht ein")
	return /** @type {LocalizedString} */ ("Please enter a valid message")
});